import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { CustomFieldType } from '../models';

export function useCrmCustomFields(enabled: boolean) {
  const { data, ...arg } = useQuery<{ crmCustomFields: CustomFieldType[] }>(
    ['dashboard-v2-crm-custom-fields'],
    async () => {
      const { data } = await $api.get('/v1/crm/field');

      return { crmCustomFields: data?.data };
    },
    {
      enabled,
      staleTime: Infinity
    }
  );

  return { ...data, ...arg };
}
